import { render } from "./VSelect.vue?vue&type=template&id=15fd4c32&scoped=true"
import script from "./VSelect.vue?vue&type=script&lang=js"
export * from "./VSelect.vue?vue&type=script&lang=js"

import "./VSelect.vue?vue&type=style&index=0&id=15fd4c32&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15fd4c32"]])

export default __exports__